var _defs, _ellipse, _path, _rect, _polygon, _polygon2, _polygon3, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPressLogoCtvNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 439.7 70.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eb0000;stroke:#fff;stroke-miterlimit:10;}.cls-2{fill:#fff;}.cls-3{fill:#005fff;}.cls-4{fill:#23be19;}.cls-5{fill:#003662;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CTVNews_horizontal_logo_f") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 35.36,
    cy: 35.34,
    rx: 34.86,
    ry: 34.84
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M256.93,285.79a16.75,16.75,0,1,1,0-16.86l5-2.9a22.51,22.51,0,1,0,0,22.66Z",
    transform: "translate(-207.1 -242.01)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 74.65,
    y: 2.29,
    width: 65.02,
    height: 66.08
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "142.62 2.29 181.72 70.19 220.83 2.29 142.62 2.29"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "127.83 13.82 86.48 13.82 86.48 19.58 104.2 19.58 104.2 56.87 110.11 56.87 110.11 19.58 127.83 19.58 127.83 13.82"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "206.51 13.82 199.64 13.82 181.72 45.23 163.8 13.82 156.93 13.82 181.72 56.87 206.53 13.82 206.51 13.82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M501.15,310.45V308H502c2.16,0,3.62-.42,4.34-1.25s1.1-2.58,1.1-5.15V266.31c0-2.7-.35-4.47-1-5.24s-2.15-1.16-4.41-1.16h-.85v-2.49h35.17l1.07,9.89h-3.06l-.13-.88c-.43-2.79-1.25-4.5-2.45-5.1s-4.57-.93-9.91-.93h-7.05v20.29h7.62c3.51,0,5.78-.29,6.74-.88s1.38-1.9,1.38-4V275h3.13v13.79h-3.13v-.72c0-1.87-.39-3.22-1.18-4-.43-.42-2-.93-6.94-.93h-7.62v18.61a4.42,4.42,0,0,0,2.71,4.4c1.85.85,5.2,1.28,9.94,1.28h1.43a6,6,0,0,0,4.47-1.47c1-1,1.66-2.77,2.1-5.32l.13-.8h3.06l-1,10.56Z",
    transform: "translate(-207.1 -242.01)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M594.44,310.45h-2.52l-15.3-41.11-13,41.11H561l-13.41-43.87a16.72,16.72,0,0,0-2.35-5.21,3.51,3.51,0,0,0-2.83-1.46h-.71v-2.49h17.15v2.49H558a5.78,5.78,0,0,0-3.1.56,2.77,2.77,0,0,0-.71,2.25,14.25,14.25,0,0,0,.65,3.9l9.57,31.28,12.74-40.48h2.45l14.94,40.7L604,266.66a17,17,0,0,0,.78-4.43c0-1.31-1.27-2.08-3.79-2.29l-.83-.05v-2.47h13.21v2.49h-.78a3.16,3.16,0,0,0-2.67,1.41,18.73,18.73,0,0,0-2.26,5.35Z",
    transform: "translate(-207.1 -242.01)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M628,311.73a43,43,0,0,1-13.45-2.1l-.14-.05-.75-11.95h3l.14.72a14,14,0,0,0,4.12,8,11.55,11.55,0,0,0,8,2.8,10.48,10.48,0,0,0,7.46-2.95,9.45,9.45,0,0,0,3.11-7.09c0-3.47-2.72-7.08-8.08-10.75l-5.15-3.56c-5-3.46-8.34-6.18-9.9-8.11a10.93,10.93,0,0,1-2.39-7.09,11.9,11.9,0,0,1,5-9.93c3.3-2.49,7.69-3.75,13.05-3.75a39.89,39.89,0,0,1,12.82,2.21l.13,0,1.18,10.25h-3l-.22-.69c-1.77-6.16-5.85-9.27-12.12-9.27a10,10,0,0,0-7,2.53,8.31,8.31,0,0,0-2.76,6.39c0,3.26,2.32,6.5,6.91,9.65l7.45,5.11c4.66,3.21,7.77,5.79,9.23,7.7a11.57,11.57,0,0,1,2.23,7.24,12.88,12.88,0,0,1-5.12,10.67c-3.4,2.61-8,3.94-13.71,3.94",
    transform: "translate(-207.1 -242.01)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M451,306.31q-1.41-1.59-1.41-6.7V258.53l42.29,51.9h1.74l.05-55.32q0-5.12,1.42-6.69c1-1,2.83-1.58,5.85-1.58h.82v-2.56H480.49v2.56h.68c3.1,0,5.12.53,6.08,1.58s1.43,3.28,1.43,6.69v39.38l-40.42-50.21h-13v2.56h.81c2.16,0,4.51,1.55,7.09,4.67l1.14,1.41v46.69q0,5.11-1.41,6.7c-.93,1-2.92,1.57-6,1.57h-.54v2.56h21.37v-2.56H457c-3.06,0-5.05-.53-6-1.57",
    transform: "translate(-207.1 -242.01)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressLogoCtvNews);
export default __webpack_public_path__ + "static/media/pressLogo_ctv_news.7fb94ba741db558f67cc7cb35c964b47.svg";
export { ForwardRef as ReactComponent };